module.exports = __webpack_public_path__ + "img/document-center.01395718.svg";